import { ReactComponent as Icon } from '../assets/star.svg';

function getColor(position: number): string {
  switch (position) {
    case 1:
      return 'text-gold';
    case 2:
      return 'text-silver';
    case 3:
      return 'text-bronze';
    default:
      return 'text-white';
  }
}

const numberFormatter = new Intl.NumberFormat('sv-SE');

export function Highscore({
  position,
  name,
  company,
  score,
}: Game.Highscore & { position: number }) {
  return (
    <div className="flex flex-row w-72 justify-between">
      <div className="flex flex-row space-x-4 items-center">
        <div
          className={`w-12 h-12 flex items-center justify-center ${getColor(
            position
          )}`}
        >
          <Icon />
          <span className={`absolute ${position > 3 ? 'text-gray-900' : 'text-white'} font-semibold`}>
            {position}
          </span>
        </div>
        <div className="">
          <span className="block text-gray-900 text-lg">{name}</span>
          <span className="block text-xs text-gray-700">{company}</span>
        </div>
      </div>
      <div className="font-bold text-lg text-gray-900">{numberFormatter.format(score)} p</div>
    </div>
  );
}
